export default __webpack_public_path__ + "static/media/menu.6244b6a1.svg";